import Button from '../../../../components/Button/Button';
import DownloadFileLink from '../../../../components/DownloadFileLink/DownloadFileLink';
import HookForm from '../../../../components/HookForm/HookForm';
import SelectDealPaymentStatuses from '../../../../components/Selects/selectDealPaymentStatuses';
import { DOCUMENT_TYPES_INVOICE } from '../../../../constants';

const HalykPaymentStatus = ({ documents, onSubmit, loading, sendPaymentSms, backHandler }) => {

  return (
    <div>
      <HookForm
        title={'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ'}
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            name: 'status',
            component: SelectDealPaymentStatuses,
          },
        ]}
        customDataTop={() => (
          <div style={{ marginBottom: 40 }}>
            {documents
              ?.filter((item) => item?.typeId === DOCUMENT_TYPES_INVOICE)
              .map((document) => (
                <DownloadFileLink document={document} />
              ))}
          </div>
        )}
        customData={() => (<Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ Ð¿ÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð²Ð·Ð½Ð¾ÑÐ°" fill onClick={sendPaymentSms} />)}
        onSubmit={onSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default HalykPaymentStatus;
